// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-annotation-dialog-textarea {
  min-width: 100%;
  max-width: 100%;
  min-height: 120px;
  max-height: 50vh;
  resize: vertical;
}

@media (max-width: 2000px) {
  .generic-dialog-footer {
    flex-direction: column;
    gap: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/dialogs/edit-annotation-dialog/EditAnnotationDialog.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,MAAM;EACR;AACF","sourcesContent":[".edit-annotation-dialog-textarea {\n  min-width: 100%;\n  max-width: 100%;\n  min-height: 120px;\n  max-height: 50vh;\n  resize: vertical;\n}\n\n@media (max-width: 2000px) {\n  .generic-dialog-footer {\n    flex-direction: column;\n    gap: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
